module.exports = __webpack_public_path__ + "img/Check-Button-Green.8b1399a6.svg";